import React from 'react';
import { useState } from 'react'
import { SiConsul } from 'react-icons/si'
import { AiOutlineGlobal } from 'react-icons/ai'
import { BsPhoneVibrate } from 'react-icons/bs'
import { CgMenuGridO } from 'react-icons/cg'
// import logo from '../../assets/logo.png'
import icon1 from '../../assets/images/features-icon-1.svg'
import icon2 from '../../assets/images/features-icon-2.svg'
import icon3 from '../../assets/images/features-icon-3.svg'
import icon4 from '../../assets/images/features-icon-4.svg'
import icon5 from '../../assets/images/features-icon-5.svg'
import icon6 from '../../assets/images/features-icon-6.svg'

//const Contact: React.FC = () => { 
const Demo = () => {

  return (

    <div id="demo" className="cards-1">
            <div className="container px-4 sm:px-8 xl:px-4">
                <h2 style={{margin:'10px'}}>Product Demonstration</h2>
                <div className="card">
                    <a href="https://airline.butterfun.com">
                        <div className="card-image">
                            <img src={icon1} alt="alternative" />
                        </div>
                        <div className="card-body">
                            <h5 className="card-title">Airline</h5>
                            <p className="mb-4">Airline landing page</p>
                            <p>(React Landing Page)</p>
                        </div>
                    </a>
                </div>
                <div className="card">
                    <a href="https://demo1.butterfun.com">
                        <div className="card-image">
                            <img src={icon2} alt="alternative"/>
                        </div>
                        <div className="card-body">
                            {/* <a className="nav-link page-scroll" href="#ability">Ability</a> */}
                            <h5 className="card-title">ERPs</h5>
                            <p className="mb-4">ERP in construction industry</p>
                            <p>(Node.js + React)</p>
                        </div>
                    </a>
                </div>
                <div className="card">
                    <a href="https://marksix.butterfun.com">
                        <div className="card-image">
                            <img src={icon3} alt="alternative"/>
                        </div>
                        <div className="card-body">
                            {/* <a className="nav-link page-scroll" href="#ability">Ability</a> */}
                            <h5 className="card-title">Marksix</h5>
                            <p className="mb-4">AI Marksix Prediction</p>
                            <p>(Python + Pytorch AI + React)</p>
                        </div>
                    </a>
                </div>
                <div className="card">
                    <a href="https://tollcheck.butterfun.com">
                        <div className="card-image">
                            <img src={icon4} alt="alternative"/>
                        </div>
                        <div className="card-body">
                            {/* <a className="nav-link page-scroll" href="#ability">Ability</a> */}
                            <h5 className="card-title">Tollcheck</h5>
                            <p className="mb-4">Toll Fee in Worldwide</p>
                            <p>(Node.js + Flutter)</p>
                        </div>
                    </a>
                </div>   
                <div className="card">
                    <a href="https://mirror9.butterfun.com/">
                        <div className="card-image">
                            <img src={icon5} alt="alternative"/>
                        </div>
                        <div className="card-body">
                            {/* <a className="nav-link page-scroll" href="#ability">Ability</a> */}
                            <h5 className="card-title">Fintech</h5>
                            <p className="mb-4">Fintech in US stock market</p>
                            <p>(Python + React)</p>
                        </div>
                    </a>
                </div>  
            </div> 
        </div>
  );
}

export default Demo